import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TimelineStep} from './timeline.step.model';

@Component({
  selector: 'app-timeline-progress-bar',
  templateUrl: './timeline-progress-bar.component.html',
  styleUrls: ['./timeline-progress-bar.component.css']
})
export class TimelineProgressBarComponent implements OnInit {

  constructor() { }

  @Input() public readonly steps: TimelineStep[];
  @Output() public clickEvent = new EventEmitter<TimelineStep>();

  ngOnInit() {
  }
  onClick(step: TimelineStep) {
    this.clickEvent.emit(step);
  }

}
